import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseDropdown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
import TypologiesAccordion from "@vueEntry/TypologiesAccordion.vue";
import { watch } from "vue";
import { createUpdatedTypologiesObj } from "@utils/TypologiesUtils";
import { useListingTypologyStore } from "@store/ListingTypologyStore";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'listingTypologyMultiSelect',
  props: {
    listingTypologies: {},
    arrowWidth: {}
  },
  emits: ["click", "typologyListChanged"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var lts = useListingTypologyStore();
    watch(function () {
      return lts.typologiesSelected;
    }, function (typologiesSelected) {
      var updatedTypologiesObj = createUpdatedTypologiesObj(typologiesSelected, lts.macroTypologiesObj);
      if (updatedTypologiesObj) emits("typologyListChanged", updatedTypologiesObj);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(BaseDropdown, {
        id: _ctx.$attrs['id'],
        "data-cy": _ctx.$attrs['data-cy'],
        "btn-label": _unref(lts).selectedTypologiesLabel,
        "arrow-width": _ctx.arrowWidth,
        "with-arrow-icon": true,
        "class": "tw-w-full",
        "btn-classes": "tw-py-10px tw-font-medium tw-text-16 tw-h-full hover:tw-bg-white ".concat(_ctx.$attrs['btn-classes'] || 'tw-rounded-l-xl aria-expanded:tw-rounded-bl-none'),
        "label-classes": "tw-truncate tw-w-full tw-text-left",
        "dropdown-classes": _ctx.$attrs['dropdown-classes']
      }, {
        "default": _withCtx(function () {
          return [_createVNode(TypologiesAccordion, {
            "btn-classes": _ctx.$attrs['accordion-btn-classes'],
            "label-classes": "tw-truncate",
            "checkbox-py": _ctx.$attrs['checkbox-py'],
            "listing-typologies": _ctx.listingTypologies
          }, null, 8 /* PROPS */, ["btn-classes", "checkbox-py", "listing-typologies"])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["id", "data-cy", "btn-label", "arrow-width", "btn-classes", "dropdown-classes"]);
    };
  }
}));